// extracted by mini-css-extract-plugin
export default {"wrap":"BuilderPage_wrap__f2f4c"};